import React, { useState } from "react";
import DatePicker from "react-datepicker";
import EdModal from "../edModal";
import { EDurationType, getFinancialYear, getLastMonthDateRange, getPreviousIndianFinancialYear, getThisMonthDateRange, isFirstDayOfFinancialYear, pnlDownloadDate, previousDay, selectQuarterDateRange, } from "@domains/utils/reportDates";
import EdButton from "../edbutton/edButton";
import moment from "moment";
const CalendarPopupDesk = (props) => {
    var _a, _b;
    const [custom, setCustom] = useState(false);
    const [openYear, setOpenYear] = useState(false);
    const financialYear = (() => {
        if (isFirstDayOfFinancialYear())
            return getPreviousIndianFinancialYear().startDate.year();
        return getFinancialYear(new Date());
    })();
    const [endDate, setEndDate] = React.useState(props.endDate);
    const [startDate, setStartDate] = React.useState(props.startDate);
    const [selectedDateRange, setSelectedDateRange] = useState("startDateSelected");
    const years = Array.from(new Array(6), (val, index) => financialYear - index);
    const dateChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        setSelectedDateRange(end ? "startDateSelected" : "endDateSelected");
    };
    const handleApply = () => {
        var _a, _b, _c, _d, _e, _f;
        setCustom(false);
        let durationType = EDurationType.NA;
        (_a = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _a === void 0 ? void 0 : _a.call(props, startDate);
        (_b = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _b === void 0 ? void 0 : _b.call(props, endDate);
        (_c = props === null || props === void 0 ? void 0 : props.setDurationType) === null || _c === void 0 ? void 0 : _c.call(props, EDurationType.NA);
        props.setFinYear(startDate.getFullYear());
        if (startDate.getFullYear() === endDate.getFullYear())
            (_d = props.setNextFinYear) === null || _d === void 0 ? void 0 : _d.call(props, endDate.getFullYear() + 1);
        else
            (_e = props.setNextFinYear) === null || _e === void 0 ? void 0 : _e.call(props, endDate.getFullYear());
        if (endDate < new Date(new Date().getFullYear(), 3, 1)) {
            props.setFinYear(endDate.getFullYear() - 1);
            (_f = props.setNextFinYear) === null || _f === void 0 ? void 0 : _f.call(props, endDate.getFullYear());
        }
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDate);
    };
    const handleCustom = () => {
        setCustom(!custom);
        props.setOpenCalendar(false);
    };
    const setFinYear = (index) => {
        var _a, _b, _c, _d;
        setOpenYear(false);
        let startDate, endDate, durationType;
        props.setOpenCalendar(false);
        props.setFinYear(financialYear - index);
        (_a = props.setNextFinYear) === null || _a === void 0 ? void 0 : _a.call(props, financialYear - index + 1);
        startDate = new Date(financialYear - index, 3, 1);
        if (index === 0) {
            durationType = EDurationType.CY;
            if (new Date(financialYear, 3, 1) > previousDay)
                endDate = new Date(financialYear + 1, 2, 31);
            else
                endDate = previousDay;
        }
        else {
            durationType = EDurationType.NA;
            endDate = new Date(financialYear - index + 1, 2, 31);
        }
        (_b = props === null || props === void 0 ? void 0 : props.setDurationType) === null || _b === void 0 ? void 0 : _b.call(props, durationType);
        (_c = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _c === void 0 ? void 0 : _c.call(props, startDate);
        (_d = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _d === void 0 ? void 0 : _d.call(props, endDate);
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDate);
    };
    const setThisMonth = () => {
        var _a, _b, _c, _d;
        let durationType = EDurationType.CM;
        props.setOpenCalendar(false);
        (_a = props === null || props === void 0 ? void 0 : props.setDurationType) === null || _a === void 0 ? void 0 : _a.call(props, durationType);
        let { startDate, endDate } = getThisMonthDateRange();
        (_b = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _b === void 0 ? void 0 : _b.call(props, startDate);
        (_c = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _c === void 0 ? void 0 : _c.call(props, endDate);
        props.setFinYear(financialYear);
        (_d = props.setNextFinYear) === null || _d === void 0 ? void 0 : _d.call(props, financialYear + 1);
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDate);
    };
    const setLastMonth = () => {
        var _a, _b, _c, _d;
        let durationType = EDurationType.LM;
        let { startDate, endDate } = getLastMonthDateRange();
        props.setOpenCalendar(false);
        (_a = props === null || props === void 0 ? void 0 : props.setDurationType) === null || _a === void 0 ? void 0 : _a.call(props, EDurationType.LM);
        (_b = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _b === void 0 ? void 0 : _b.call(props, startDate);
        (_c = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _c === void 0 ? void 0 : _c.call(props, endDate);
        props.setFinYear(financialYear);
        (_d = props.setNextFinYear) === null || _d === void 0 ? void 0 : _d.call(props, financialYear + 1);
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDate);
    };
    const setQuarter = (index) => {
        var _a, _b, _c;
        const { startDate, endDate } = selectQuarterDateRange(index);
        let endDates = endDate;
        props.setOpenCalendar(false);
        props.setFinYear(financialYear);
        (_a = props.setNextFinYear) === null || _a === void 0 ? void 0 : _a.call(props, financialYear + 1);
        (_b = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _b === void 0 ? void 0 : _b.call(props, startDate);
        let durationType;
        if (index === 0) {
            endDates = previousDay;
            durationType = EDurationType.CQ;
        }
        else {
            durationType = EDurationType.LQ;
        }
        (_c = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _c === void 0 ? void 0 : _c.call(props, endDates);
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDates);
    };
    const disableCalenderApply = () => {
        if (props.disableCalenderApply)
            return props.disableCalenderApply(startDate, endDate);
        return startDate && endDate ? false : true;
    };
    React.useEffect(() => {
        if (custom) {
            if (props.startDate)
                setStartDate(props.startDate);
            if (props.endDate)
                setEndDate(props.endDate);
            setSelectedDateRange;
        }
    }, [custom]);
    React.useEffect(() => {
        if (!props.openCalendar)
            setOpenYear(false);
    }, [props.openCalendar]);
    React.useEffect(() => {
        disableCalenderApply();
    }, [startDate, endDate]);
    return (React.createElement("div", { style: { display: "inline" }, className: "common-download-newtheme" },
        props.openCalendar && (React.createElement("div", null,
            React.createElement("div", { className: `calendar_container ${((_a = props === null || props === void 0 ? void 0 : props.customFields) === null || _a === void 0 ? void 0 : _a.length) > 0 ? "h-auto" : ""} ` },
                React.createElement("div", { className: "calendar_arrow" }),
                React.createElement("div", { className: "calendar_list" },
                    React.createElement("span", { onClick: setThisMonth }, "This Month"),
                    React.createElement("span", { onClick: setLastMonth }, "Last Month"),
                    React.createElement("span", { onClick: () => {
                            setQuarter(0);
                        } }, "This Quarter"),
                    React.createElement("span", { onClick: () => {
                            setQuarter(1);
                        } }, "Last Quarter"),
                    ((_b = props === null || props === void 0 ? void 0 : props.customFields) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                        props.customFields.map((customField) => {
                            return (React.createElement("span", { onClick: () => customField.Functionality() }, customField.displayText));
                        }),
                    React.createElement("span", { className: "yearly", onClick: () => setOpenYear(!openYear) },
                        "Yearly",
                        React.createElement("i", { className: "edel-icon-arrow-right1" })),
                    props.customTime && (React.createElement("span", { onClick: handleCustom },
                        props.customTimeText
                            ? props.customTimeText
                            : "Custom Time Range",
                        React.createElement("i", { className: "edel-icon-arrow-right1" }))))),
            openYear && (React.createElement("div", { className: "year_container" }, years.map((finYear, index) => {
                return (React.createElement("div", { className: "financial_year", key: index },
                    React.createElement("span", { onClick: () => setFinYear(index) },
                        "FY ",
                        finYear,
                        "-",
                        (finYear + 1).toString().substring(2))));
            }))))),
        React.createElement("div", { className: "common-popup-customrange calendar_pnl_ui" },
            React.createElement(EdModal, { show: custom, setShow: setCustom, modalTitle: "modalHoldingTitle", title: "Custom Time Range", showFooter: false },
                React.createElement("div", { className: "pandLcalendar common-datepicker" },
                    props.TopMostReactNodeInCustomPopUp
                        ? props === null || props === void 0 ? void 0 : props.TopMostReactNodeInCustomPopUp(startDate, endDate)
                        : null,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12 col-lg-12 pandLcalendar-form" },
                            React.createElement("div", { className: "row calendar--row date-input-section" },
                                React.createElement("div", { className: "col pdr-0" },
                                    React.createElement("div", { className: `DMSanM_14_500 ${selectedDateRange === "startDateSelected"
                                            ? "txt-midight-blue"
                                            : "txt-secondary-gray"}` }, "From Date"),
                                    React.createElement("div", { className: `${selectedDateRange === "startDateSelected"
                                            ? "bdr-1-midnight"
                                            : ""} input-group yearDropdown common-datepicker align-items-center ` },
                                        React.createElement("input", { type: "text", className: `form-control date-drawer-input-field  ${selectedDateRange === "startDateSelected"
                                                ? "txt-midight-blue"
                                                : "txt-secondary-gray"}`, placeholder: "dd-mm-YY", value: moment(startDate).format("D-MMM-YY"), readOnly: true }),
                                        React.createElement("a", { className: "input-group-append" },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" }))))),
                                React.createElement("div", { className: "col pdl-0" },
                                    React.createElement("div", { className: `DMSanM_14_500  ${selectedDateRange === "endDateSelected"
                                            ? "txt-midight-blue"
                                            : "txt-secondary-gray"}

                     ` }, "To Date"),
                                    React.createElement("div", { className: `${selectedDateRange === "endDateSelected"
                                            ? "bdr-1-midnight"
                                            : ""} input-group yearDropdown common-datepicker align-items-center ` },
                                        React.createElement("input", { type: "text", className: `form-control date-drawer-input-field ${selectedDateRange === "endDateSelected"
                                                ? "txt-midight-blue"
                                                : "txt-secondary-gray"}`, placeholder: "dd-mm-YY", value: selectedDateRange === "endDateSelected"
                                                ? "Select End Date"
                                                : moment(endDate).format("D-MMM-YY"), readOnly: true }),
                                        React.createElement("a", { className: "input-group-append" },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" })))))),
                            React.createElement("div", { className: "pdt-20 yearDropdown singleDatePicker holdingReportsDate rangeDatePickerContainer keyboard-daychange " },
                                React.createElement(DatePicker, { dateFormat: "d-MMM-yy", onChange: dateChange, startDate: startDate, endDate: endDate, selectsRange: true, inline: true, selected: startDate, minDate: props.minDate ? props.minDate : pnlDownloadDate, maxDate: previousDay, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), showYearDropdown: true, showMonthDropdown: true, scrollableYearDropdown: true, yearDropdownItemNumber: props.minDate
                                        ? previousDay.getFullYear() -
                                            props.minDate.getFullYear() +
                                            1
                                        : previousDay.getFullYear() -
                                            pnlDownloadDate.getFullYear() +
                                            1 })))),
                    React.createElement("div", { className: "custom_buttons" },
                        React.createElement("button", { onClick: () => setCustom(false), className: "midnight-blue-border ed_button" }, "Cancel"),
                        React.createElement(EdButton, { className: "active", onClick: handleApply, disabled: disableCalenderApply(), value: " Apply", btnTyp: "blue-one" })))))));
};
export default CalendarPopupDesk;
